export default "__VITE_ASSET__DbIdR8Gr__"